import {Evaluator, GraphNode} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {AnyImageOpContext, ImageOpNode, ImageOpOutputs} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/utils/get-property/definition"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeGetProperty"}

@registerImageOpNode
export class ImageOpNodeGetProperty<Returns> extends ImageOpNode<typeof definition> {
    override get definition() {
        return nodeDefinition
    }

    override run = async (evaluator: Evaluator<AnyImageOpContext>): Promise<ImageOpOutputs<typeof definition>> => {
        const key = this.parameters.key
        const value = await evaluator.get(this.parameters.value as GraphNode<{[key in typeof key]: Returns}, AnyImageOpContext>)
        const parsedValue = this.definition.validation.returns.safeParse(value?.[key])
        if (!parsedValue.success) {
            throw new Error(`Failed to parse value: ${parsedValue.error.message}`)
        }
        return parsedValue.data
    }
}
